import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
export const GHOST_SUFFIX = 'Treat anything marked unverified hearsay as unverified. You may paraphrase hearsay and black-hat notes, but never quote them.';
export const ALTERNATE_SUFFIX = 'Use Keep as separate draft.';
/** The chips for one section, in display order. Pure, so the prompts are unit-testable. */ export function buildQuickActions(d) {
    const scope = d.sectionAnchor ? `the section anchored at ${d.sectionAnchor}` : `this ${d.unit === 'rfi' ? 'answer' : 'section'}`;
    const out = [];
    const add = (id, label, prompt)=>out.push({
            id,
            label,
            prompt
        });
    if (d.unit === 'rfi') {
        add('draft', 'Draft from sources', `Draft ${scope} from the sources you can see. Change only ${scope}.`);
        if (d.wordLimit) {
            add('tighten', `Tighten to ${d.wordLimit} words`, `Tighten ${scope} to ${d.wordLimit} words or fewer. Change only ${scope}.`);
        }
        add('check', 'Check it answers the question', `Check that ${scope} answers the question that was asked, and list anything it misses. Change only ${scope}.`);
        if (d.hasPastAnswer) {
            add('tone', 'Match our RFI #1 tone', `Rewrite ${scope} to match the tone of our answer to RFI #1. Change only ${scope}.`);
        }
        add('alternate', 'Make an alternate draft', `Write an alternate draft of ${scope}. ${ALTERNATE_SUFFIX}`);
        return out;
    }
    const refs = d.requirementRefs?.filter(Boolean) ?? [];
    if (refs.length) {
        const list = refs.join(', ');
        add('check', `Check against ${list}`, `Check ${scope} against ${list} and list any gaps. Change only ${scope}.`);
    }
    if (d.firstPartialRequirement) {
        add('fix', `Fix the ${d.firstPartialRequirement} gap`, `Fix the gap against ${d.firstPartialRequirement} in ${scope}. Change only ${scope}.`);
    }
    if (d.firstWinTheme) {
        add('theme', `Weave in the ${d.firstWinTheme} theme`, `Weave the ${d.firstWinTheme} win theme into ${scope}. Change only ${scope}.`);
    }
    if (d.competitor) {
        add('ghost', `Ghost ${d.competitor}`, `Ghost ${d.competitor} in ${scope}: subtly highlight our strengths where they are weak. Change only ${scope}. ${GHOST_SUFFIX}`);
    }
    add('cut', 'Cut 10%', `Cut ${scope} by about 10% without losing substance. Change only ${scope}.`);
    return out;
}
export function QuickActions({ actions, busy, onSend }) {
    if (actions.length === 0) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-wrap gap-[var(--space-2)]",
        children: actions.map((a)=>/*#__PURE__*/ _jsx(SpecraButton, {
                "data-testid": Testids.officeWorkspace.quickAction,
                disabled: busy,
                onClick: ()=>onSend(a.prompt),
                size: "xs",
                variant: "secondary",
                children: a.label
            }, a.id))
    });
}
